import React from 'react';
import { useHistory } from 'react-router-dom';
import { extractParameters, handleSearchQuery } from '../pages/manager/components/context';

export function applyAliasesToFilters(spec, filters) {
    // If aliases is set, we wan't to check if some keys in filters context corresponded to some
    // filters in new spec. If we find an alias for the key found in the filters. We delete this key
    // and replace it with his alias.
    if (!('aliases' in spec)) {
        return filters;
    }
    return Object.keys(filters).reduce((acc, key) => {
        const aliasKey = spec.aliases[key] || key;
        acc[aliasKey] = filters[key];
        return acc;
    }, {});
}

export function buildSearchString(spec, filters) {
    return Object.entries(handleSearchQuery(spec, filters))
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
}

export function useCurrentPageFilters(spec) {
    const history = useHistory();
    const initialFilters = applyAliasesToFilters(spec, extractParameters(spec, history.location.search));
    const [filters, setLocalFilters] = React.useState(initialFilters);

    const setFilters = React.useCallback(
        (newFilters = {}) => {
            const aliasedFilters = applyAliasesToFilters(spec, newFilters);
            history.push({ search: buildSearchString(spec, aliasedFilters) });
            setLocalFilters(aliasedFilters);
        },
        [history]
    );
    return [filters, setFilters];
}
